import React,{useEffect,useState} from 'react';
import Navbar from './Navbar';
import { useTranslation } from 'react-i18next';


const TermsCondintion = (props) =>{
    const { t, i18n } = useTranslation();
    const isArabic = i18n.language === 'ar';

    return(
        <div style={{ backgroundColor: '#000000', height: '100%', overflow: 'hidden' }}>
            <div className='outer-container pt-1' style={{ height: 'calc(100vh - 64px)', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                    <div className='inner-container' style={{ width: '60%', maxHeight: '70vh', overflowY: 'hidden', boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.1)', padding: '20px', backgroundColor: '#e6e6e6', borderRadius: '20px' }}>
                        <h4 className={`pt-3 pb-3 ${isArabic ? 'notokufi-bold' : 'avenir-heavy'}`} style={{ color: '#FF8319' }}>{t('terms.title')}</h4>
                        <div className='text-scroller mt-3' style={{ overflowY: 'auto', maxHeight: 'calc(60vh - 100px)' }}>
                            <p className={`${isArabic ? 'notokufi-regular' : 'avenir-regular'}`}>{t('terms.text')}</p>
                        </div>
                        <div className='text-end pt-3'>
                            <a href='/' className={`btn sign-up-button ${isArabic ? 'notokufi-regular' : 'avenir-regular'}`} style={{ textDecoration: "none", color: "black" }}>Cancel</a>
                        </div>
                    </div> 
            </div>
        </div>
    )
};

export default TermsCondintion;